import {
    keysFilter,
    noUndefFilter
} from './';

function objectValueMapper({object, key}) {
    return object[key];
}

function objectEntryMapper({object, key}) {
    const value = objectValueMapper({object, key});

    return [key, value];
}

function getObjectKeys(object) {
    return Object.keys(object);
}

function getMappedObject(object, mapper) {
    return (
        getObjectKeys(object)
            .map((key, index, array) => (
                mapper({object, key, index, array})
            ))
    );
}

function getObjectValues(object) {
    return getMappedObject(object, objectValueMapper);
}

function getObjectEntries(object) {
    return getMappedObject(object, objectEntryMapper);
}

function mergeReducer({result, key, value}) {
    return {
        ...result,
        [key]: value
    };
}

function getFilteredObject(object, filter, reducer) {
    return (
        getObjectEntries(object)
            .filter(([key, value], index, array) => (
                filter({key, value, index, array})
            ))
            .reduce((result, [key, value], index, array) => (
                reducer({result, key, value, index, array})
            ), {})
    );
}

function getKeyedObject(object, keys) {
    return getFilteredObject(object, keysFilter(keys), mergeReducer);
}

function getNoUndefObject(object) {
    return getFilteredObject(object, noUndefFilter, mergeReducer);
}

export {
    getObjectKeys,
    getObjectValues,
    getObjectEntries,
    getKeyedObject,
    getNoUndefObject
};
